"use strict";

//	App interface

export let AppInterface = {
	appMediaQuery: 0,
	appSize: "xs",
	appOrientation: "portrait",

	scrollTop: 0,
	scrollBottom: 0,
	scrollPerc: 0,
	scrollDirection: "down"
}

//	Active image displacement

export function activeImageDisplacement( images ) {
	if ( images.length != 0 && images != null ) {
		setImageDisplacement( (images.length) ? images : [images] );
	}
}

//	Set image displacement

function setImageDisplacement( images ) {
	images.forEach( function( self ) {
		self.parentNode.addEventListener( "mousemove", function( e ) {
			let x = ( (e.offsetX - self.offsetLeft) / self.offsetWidth ) * 100,
				y = ( (e.offsetY - self.offsetTop) / self.offsetHeight ) * 100

			self.style.webkitTransformOrigin = `${x}% ${y}%`;
			self.style.transformOrigin = `${x}% ${y}%`;
		});
	});
}

//	Get image mage displacement offset

/*function getImageDisplacementOffset( e ) {
	return {
		/x: ( (e.offsetX - (e.currentTarget.offsetLeft - 96)) / (e.currentTarget.offsetWidth + 96) ) * 100,
		y: ( (e.offsetY - (e.currentTarget.offsetTop - 96)) / (e.currentTarget.offsetHeight + 96) ) * 100
	}
}*/